__turbopack_context__.v({
  "activeTabDot": "_1nZkda_activeTabDot",
  "activeTabLabel": "_1nZkda_activeTabLabel",
  "backArrow": "_1nZkda_backArrow",
  "desktopTabs": "_1nZkda_desktopTabs",
  "exploreCta": "_1nZkda_exploreCta",
  "homeBackLabel": "_1nZkda_homeBackLabel",
  "logoLink": "_1nZkda_logoLink",
  "menuIcon": "_1nZkda_menuIcon",
  "menuToggle": "_1nZkda_menuToggle",
  "mobileGiftingNew": "_1nZkda_mobileGiftingNew",
  "mobileMenuDivider": "_1nZkda_mobileMenuDivider",
  "mobileTabGift": "_1nZkda_mobileTabGift",
  "mobileTabGiftLabel": "_1nZkda_mobileTabGiftLabel",
  "mobileTabItem": "_1nZkda_mobileTabItem",
  "mobileTabsRow": "_1nZkda_mobileTabsRow",
  "navBackdrop": "_1nZkda_navBackdrop",
  "navInner": "_1nZkda_navInner",
  "navRoot": "_1nZkda_navRoot",
  "promoBanner": "_1nZkda_promoBanner",
  "rightActions": "_1nZkda_rightActions",
  "tabActive": "_1nZkda_tabActive",
  "tabGift": "_1nZkda_tabGift",
  "tabLink": "_1nZkda_tabLink",
  "topRow": "_1nZkda_topRow",
});
